"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("../Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Contextual Nav Header
 */
var ContextualNavHeader = /*#__PURE__*/function (_React$Component) {
  _inherits(ContextualNavHeader, _React$Component);

  var _super = _createSuper(ContextualNavHeader);

  function ContextualNavHeader() {
    _classCallCheck(this, ContextualNavHeader);

    return _super.apply(this, arguments);
  }

  _createClass(ContextualNavHeader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          showBackBtn = _this$props.showBackBtn,
          title = _this$props.title,
          subTitle = _this$props.subTitle,
          aside = _this$props.aside,
          isToggleList = _this$props.isToggleList,
          toggleList = _this$props.toggleList,
          children = _this$props.children;
      return /*#__PURE__*/_react.default.createElement("section", {
        className: "context-nav"
      }, /*#__PURE__*/_react.default.createElement("header", {
        className: "context-header ".concat(showBackBtn ? '--large' : '')
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "l-padding"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "context-header-inner"
      }, showBackBtn && /*#__PURE__*/_react.default.createElement(_Button.default, {
        onClick: this.props.onRequestBack,
        variant: _Button.default.Variant.LINK,
        iconName: "arrow-left",
        iconPosition: "before"
      }, this.props.backBtnLabel), /*#__PURE__*/_react.default.createElement("div", {
        className: "context-title"
      }, /*#__PURE__*/_react.default.createElement("h3", {
        className: "paragraph"
      }, /*#__PURE__*/_react.default.createElement("strong", null, title)), /*#__PURE__*/_react.default.createElement("p", null, subTitle))), aside ? aside : null, children && /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "content-nav__mobile-menu ".concat(isToggleList ? 'content-nav__mobile-menu--open' : ''),
        onClick: toggleList,
        onKeyPress: toggleList
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "vh"
      }, isToggleList ? 'Hide Menu' : 'Show Menu')))), children);
    }
  }]);

  return ContextualNavHeader;
}(_react.default.Component);

exports.default = ContextualNavHeader;

_defineProperty(ContextualNavHeader, "propTypes", {
  title: _propTypes.default.string.isRequired,
  subTitle: _propTypes.default.string.isRequired,
  showBackBtn: _propTypes.default.bool,
  backBtnLabel: _propTypes.default.string,
  isToggleList: _propTypes.default.bool,
  toggleList: _propTypes.default.func,
  onRequestBack: _propTypes.default.func,
  aside: _propTypes.default.node,
  children: _propTypes.default.node
});

_defineProperty(ContextualNavHeader, "defaultProps", {
  aside: null,
  showBackBtn: false,
  backBtnLabel: 'Back',
  onRequestBack: function onRequestBack() {
    window.history.back();
  },
  children: null,
  isToggleList: false,
  toggleList: function toggleList() {}
});
//# sourceMappingURL=ContextualNavHeader.js.map